module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/kibt-fe-shop-c-outside-h5/prod/images/shoppping-bag.b613998042.png";